<template>
  <div class="pagination">    
    <Button
      v-if="parseInt(this.$route.query.page) !== 1"
      title="Prev"
      to=""
      showChevron=true
      active="true"
      v-on:handleClick="$emit('handleLeftButton')"
    />

    <span class="pagination--current-page">
      {{ `${parseInt(this.$route.query.page)} / ${pages}` }}
    </span>

    <Button
      v-if="parseInt(this.$route.query.page) !== pages"
      title="Next"
      to=""
      showChevron=true
      active="true"
      v-on:handleClick="$emit('handleRightButton')"
    />
  </div>
</template>

<script>
  import Button from './button.vue'

  export default {
    name: 'pagination',
    props: [
      'pages'
    ],
    components: {
      Button
    }
  }
</script>

<style lang="scss">
  .pagination {
    
    .button {
      float: left;

      span {
        color: var(--blue);
      }
    }

    .button-bgcolor {
      
      span {
        color: var(--white);
      }
    }

    &--current-page {
      display: inline-block;
      border-radius: 3px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 5px 10px;
      font-weight: bold;
      float: left;
    }
  }
</style>